<template>
  <div>
    <b-modal
      v-model="show" 
      title="Chave de Segurança"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @hide='closeModal'
    >

      <div
        class="d-flex justify-content-center align-items-center pb-2 mb-4"
      >
        <img src="@/assets/chaveseguranca.png" width="100" />
      </div>

      <template v-slot:modal-footer>
        <div class="row">
          <b-btn block variant="default" @click="validarToken">Tentar novamente</b-btn>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {    
      makeAssertionOptions: null,
      assertionResponse: null,
      isHardware: false,
      show: false,
      model: {},
    };
  },
  methods: {
    closeModal() {
      this.model = {};
      this.show = false;
      this.$emit('close')
    },
    openModal() {
      this.show = true;

      this.validarToken()
    },
    async validarToken(){
        let th = this;   
        var data = JSON.parse(localStorage.getItem('challenge')); 
        th.makeAssertionOptions = data;

        await th.GetAssertionOptions();

        let challengeResponse = {
            assertionResponse: th.assertionResponse,
            usId: th.makeAssertionOptions.usId,
        }

        th.$emit(`proximoPassoValidacaoToken`, challengeResponse);

        th.show = false
    },    
    async GetAssertionOptions() {
      const th = this;

      if (th.makeAssertionOptions.status !== 'ok') {
        return;
      }

      const challenge = th.makeAssertionOptions.challenge
        .replace(/-/g, '+')
        .replace(/_/g, '/');
      th.makeAssertionOptions.challenge = Uint8Array.from(
        atob(challenge),
        (c) => c.charCodeAt(0)
      );

      th.makeAssertionOptions.allowCredentials.forEach(function (listItem) {
        var fixedId = listItem.id.replace(/\_/g, '/').replace(/\-/g, '+');
        listItem.id = Uint8Array.from(atob(fixedId), (c) => c.charCodeAt(0));
      });

      var credential = null;
      try {
        th.isHardware = true;
        credential = await navigator.credentials.get({
          publicKey: th.makeAssertionOptions,
        });
      } catch (err) {
        th.$api.UI.ShowError('Erro', err);
      }

      try {
        th.assertionResponse = th.verifyAssertionWithServer(credential);
      } catch (e) {
        th.$api.UI.ShowError('Erro', `Não foi possível verificar a chave ${e}`);
      }
    },
    verifyAssertionWithServer(assertedCredential) {
      const authData = new Uint8Array(
        assertedCredential.response.authenticatorData
      );
      const clientDataJSON = new Uint8Array(
        assertedCredential.response.clientDataJSON
      );
      const rawId = new Uint8Array(assertedCredential.rawId);
      const sig = new Uint8Array(assertedCredential.response.signature);
      var data = {
        id: assertedCredential.id,
        rawId: this.coerceToBase64Url(rawId),
        type: assertedCredential.type,
        extensions: assertedCredential.getClientExtensionResults(),
        response: {
          authenticatorData: this.coerceToBase64Url(authData),
          clientDataJSON: this.coerceToBase64Url(clientDataJSON),
          signature: this.coerceToBase64Url(sig),
        },
      };
      return JSON.stringify(data);
    },
    coerceToBase64Url(thing) {
      if (Array.isArray(thing)) {
        thing = Uint8Array.from(thing);
      }

      if (thing instanceof ArrayBuffer) {
        thing = new Uint8Array(thing);
      }

      if (thing instanceof Uint8Array) {
        var str = '';
        var len = thing.byteLength;

        for (var i = 0; i < len; i++) {
          str += String.fromCharCode(thing[i]);
        }
        thing = window.btoa(str);
      }

      if (typeof thing !== 'string') {
        throw new Error('could not coerce to string');
      }

      thing = thing.replace(/\+/g, '-').replace(/\//g, '_').replace(/=*$/g, '');

      return thing;
    }
  }
};
</script>
